import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import AuthWrapper from '@/components/AuthWrapper';
import GlobalBackground from '@/components/GlobalBackground';
import LoaderScreen from '@/components/LoaderScreen';
import { WelcomeModal } from '@/components/WelcomeModal/WelcomeModal';

import { LocalStorageProvider } from '@/context/localStorage.context';

const AppLayout: React.FC = () => {
  return (
    <LocalStorageProvider>
      <GlobalBackground>
        <AuthWrapper>
          <Suspense fallback={<LoaderScreen />}>
            <Outlet />
          </Suspense>
          <WelcomeModal />
        </AuthWrapper>
      </GlobalBackground>
    </LocalStorageProvider>
  );
};

export default AppLayout;
